/* eslint-disable react-refresh/only-export-components */
import PrivateLayout from '@/modules/global-components/PrivateLayout';
import { mainNavRoutes } from './main/routes';
import { exportRoutes } from './export/routes';
import { masterRoutes } from './masters/routes';
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { lazy } from 'react';
import NotFoundPage from '@/modules/global-components/not-found';
import ResetPsPage from '@/modules/auth/reset-password/ResetPsPage';
import { reportRoutes } from './reports/routes';
import { utilitiesRoutes } from './utilities/route';
import { accountingRoutes } from './accounting/routes';
import { customerRoutes } from './customer-routes/routes';
import { marketingRoutes } from './marketing/routers';

const Settings = lazy(() => import('@/modules/settings/Settings'));

export const mainRoutes = [
  {
    path: 'main',
    Component: PrivateLayout,
    children: [
      ...customerRoutes,
      ...mainNavRoutes,
      ...exportRoutes,
      ...accountingRoutes,
      ...masterRoutes,
      ...reportRoutes,
      ...utilitiesRoutes,
      ...marketingRoutes,
      {
        path: 'settings',
        element: withSuspense(Settings),
      },
      {
        path: 'reset-password',
        Component: ResetPsPage,
      },
      {
        path: '*',
        element: <NotFoundPage className="min-h-none min-w-none size-full" />,
      },
    ],
  },
];
